import { HttpError, createApiClient, parseOrThrow } from '../../api';
import type { ViewablePerson, ViewAsSwitch } from '../types';

import { viewAsAnswerSchema, viewablePeopleSchema } from './schemas';

const VIEW_AS_ENDPOINT = '/v2/auth/view-as';
const VIEW_AS_EXIT_ENDPOINT = '/v2/auth/view-as/exit';
const VIEWABLE_PEOPLE_ENDPOINT = '/v2/auth/view-as/people';

const { request } = createApiClient();

const NOTHING_TO_END: ViewAsSwitch = { landingPage: null };

const switchOf = (raw: unknown): ViewAsSwitch => ({
  landingPage: parseOrThrow(viewAsAnswerSchema, raw ?? {}, 'view as').layoutInfo?.landingPage ?? null,
});

const nothingToEndOnTheServer = (error: unknown): boolean =>
  error instanceof HttpError && (error.code === 'NOT_VIEWING' || error.status === 404);

export const startViewAs = async (userId: string): Promise<ViewAsSwitch> =>
  switchOf(await request('post', VIEW_AS_ENDPOINT, { body: { userId } }));

export const endViewAs = async (): Promise<ViewAsSwitch> => {
  try {
    return switchOf(await request('post', VIEW_AS_EXIT_ENDPOINT, { body: {} }));
  } catch (error) {
    if (nothingToEndOnTheServer(error)) return NOTHING_TO_END;
    throw error;
  }
};

export const fetchViewablePeople = async (search: string, signal?: AbortSignal): Promise<ViewablePerson[]> => {
  const raw = await request('get', VIEWABLE_PEOPLE_ENDPOINT, { params: search === '' ? undefined : { q: search }, signal });
  return parseOrThrow(viewablePeopleSchema, raw, 'view as people').people.map((person) => ({
    id: person._id,
    name: person.name ?? '',
    email: person.email ?? null,
  }));
};
